"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaModelSignalPinsRowSchema = exports.SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE = void 0;
const zod_1 = require("zod");
exports.SIGMA_MODEL_SIGNAL_PINS_TABLE_DIRECTIVE = 'sigma-model-signal-pins-table';
exports.SigmaModelSignalPinsRowSchema = zod_1.z.object({
    rowKey: zod_1.z
        .string()
        .describe('The row key, copied exactly from the "Sigma model signal rows" page context. Never invent one.'),
    modelSignalName: zod_1.z.string().describe('The sigma model signal name the row key belongs to.'),
    block: zod_1.z
        .string()
        .nullable()
        .describe('The block or array element label from the page context, or null for a simple signal.'),
    datasheetName: zod_1.z
        .string()
        .nullable()
        .describe('What the datasheet calls this signal, or null when the datasheet uses the model name.'),
    pins: zod_1.z.array(zod_1.z.string()).describe('The physical pin designators this signal is on, as printed in the datasheet.'),
});
//# sourceMappingURL=SigmaModelSignalPinsTable.js.map